export default __webpack_public_path__ + "static/Construction-779859be90a8e1a0917cbbfbdcbfce7ff2fdabe31ed0a1f72d0dff58830c7487.png";